/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/inbox/supplierInvoicesInbox/sessionStorageHelper"/>

import * as eventBus from 'Core/Medius.Core.Web/Scripts/eventBus';
import EventNames = require('Core/Medius.Core.Web/Scripts/events/eventNames');
import * as EventMessages from 'Core/Medius.Core.Web/Scripts/events/eventMessages';

export const sessionStorageKey = (sessionId: string) => `${'supplierInvoicesInbox'}_${sessionId}`;

export const ToggleNewInboxMessage = 'TOGGLE_NEW_INBOX';

enum InboxMode {
    Mine = 'mine',
    All = 'all'
}

export type SupplierInvoicesInboxSessionStorage = {
    tab: string;
    mine: string;
    all?: string;
};

export const initialSessionStorage: SupplierInvoicesInboxSessionStorage = {
    tab: InboxMode.Mine,
    mine: JSON.stringify({ url: `#/Tasks?tab=${InboxMode.Mine}` }),
    all: JSON.stringify({ url: `#/Tasks?tab=${InboxMode.All}` })
};

export const createInboxHash = (window: Window, tenantId: string) => {
    const inboxSessionStorage = getInboxSessionStorageOrInitialize(window.sessionStorage, tenantId);
    const newHash = createHash(inboxSessionStorage);

    return newHash;
};

const createHash = (inboxSessionStorage: SupplierInvoicesInboxSessionStorage): string => {
    const tabData =
        inboxSessionStorage.tab === InboxMode.Mine
            ? inboxSessionStorage.mine || initialSessionStorage.mine
            : inboxSessionStorage.all || initialSessionStorage.all;

    try {
        const parsed = JSON.parse(tabData);
        return parsed.url;
    } catch (error) {
        console.error('[Inbox] Error parsing tab data in createHash:', error);
    }
};

const getInboxSessionStorageOrInitialize = (
    sessionStorage: Storage,
    tenantId: string
): SupplierInvoicesInboxSessionStorage => {
    const sessionStorageData = sessionStorage.getItem(sessionStorageKey(tenantId));
    return sessionStorageData ? JSON.parse(sessionStorageData) : initialSessionStorage;
};

export const handleStateChange = (url: string) => {
    const message: EventMessages.InboxStateChangedMessage = {
        url: url
    };
    eventBus.trigger(EventNames.inboxStateChanged, message);
};
